// extracted by mini-css-extract-plugin
module.exports = {"root":"IconEnquiry_root__3Ie94","marketplaceColorStroke":"IconEnquiry_marketplaceColorStroke__3W9oh"};